import React from 'react';
import classNames from 'classnames/bind';
import { Image } from '@thd-olt-component-react/image';
import styles from '../components/text-an-expert.module.scss';

let cx = classNames.bind(styles);

export const Android = () => (
  <a className={cx('business-chat__link')} href="sms:38698">
    <div className={cx('banner')}>
      <Image
        alt="Chat Icon"
        asset="chat_expert_online.svg"
        className={cx('banner__icon')}
        height="50"
        width="50"
      />
      <div className={cx('banner__text')}>
        <span>TEXT A HOME DEPOT EXPERT</span>
      </div>
      <Image
        alt="Chat Icon Secondary"
        asset="chat_button_android.svg"
        className={cx('banner__icon')}
        height="50"
        width="50"
      />
    </div>
  </a>
);
